enum VictimsDisplayMode {
    List = "list",
    Slider = "slider"
}

export default VictimsDisplayMode;